export const wait = (mills = 1000) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, mills);
  });
}


// WEBPACK FOOTER //
// ./src/libs/wait.js